// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m7-c";
export var backButton = "_m7-4";
export var backIcon = "_m7-5";
export var chevronShortcut = "_m7-6";
export var container = "_m7-1";
export var editor = "_m7-8";
export var editorWrapper = "_m7-7";
export var prefix = "_m7-2";
export var searchIcon = "_m7-3";
export var suffix = "_m7-9";
export var suffixContent = "_m7-a";
export var suffixText = "_m7-b";
export var wrapper = "_m7-0";